import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Collapse, } from "@mui/material";
import isUndefined from "lodash.isundefined";
import React from "react";
import { useUpdateEffect } from "react-use";
import { CollapseHeader } from "./CollapseHeader.js";
import { TypographyWithIcon } from "./text/Typography.js";
export const CollapseSection = ({ id, children, isInitiallyExpanded, expanded, setExpanded, Icon, title, titleVariant = "h4", titleColor = "primary", iconButtonColor = "primary", itemCount, CollapsedHint, ActionButtons, disableAutoExpand = false, hideItemCountOnExpand = false, collapseTimeout, fullWidth, ...props }) => {
    const [isExpanded, setIsExpanded] = useExpanded(!isUndefined(isInitiallyExpanded)
        ? isInitiallyExpanded
        : !isUndefined(itemCount)
            ? itemCount && itemCount > 0
                ? true
                : false
            : true, expanded, setExpanded);
    useUpdateEffect(() => {
        if (disableAutoExpand)
            return;
        if (itemCount && itemCount > 0) {
            setIsExpanded(true);
        }
        else if (itemCount === 0) {
            setIsExpanded(false);
        }
    }, [itemCount]);
    return (_jsxs(Box, { id: id, width: "100%", children: [_jsx(CollapseHeader, { isExpandable: true, isExpanded: isExpanded, setIsExpanded: setIsExpanded, title: _jsx(TypographyWithIcon, { count: hideItemCountOnExpand && isExpanded ? undefined : itemCount, icon: Icon, variant: titleVariant, color: titleColor, fullWidth: fullWidth, children: title }), CollapsedHint: CollapsedHint, ActionButton: ActionButtons, iconButtonColor: iconButtonColor, fullWidth: fullWidth, ...props }), _jsx(Collapse, { in: isExpanded, timeout: collapseTimeout, children: _jsx(Box, { children: children }) })] }));
};
function useExpanded(isInitiallyExpanded, expanded, setExpanded) {
    const [isExpanded, setIsExpanded] = React.useState(isInitiallyExpanded);
    if (expanded !== undefined && setExpanded !== undefined) {
        return [expanded, setExpanded];
    }
    return [isExpanded, setIsExpanded];
}
//# sourceMappingURL=CollapseSection.js.map